import GroupToggle from "./components/GroupToggle"
import App from "./components/App"
import Store from './services/Store'
import Tracking from './utils/Tracking'
import PsToJs from './components/PsToJs'
import testLocalStorage from './utils/testLocalStorage';
import initCartFabAttention from './utils/initCartFabAttention'
import moment from 'moment-timezone';
import {} from './utils/modal';
import '../../app/assets/javascripts/lib/bootstrap-datetimepicker.js';
import {init as initRating} from "./utils/Rating";

const client = {
  /**
   * Init App component with global store.
   */
  initApp: function () {
    const initialState = {};
    const store = Store.create(App.init(initialState), App.update)

    store.subscribe(() => {
      App.view($("body"), store.getState(), store.dispatch)
    })

    store.dispatch({type: "INIT"})

  },

  initTracking: function () {
    const tracking = Tracking.init();
    window.Skubacz.tracking = tracking;
    // Backwards compatiblity for old AM, once all AM themes are upgrades this can be removed
    window.Skubacz.initAnalytics = function (clientId) {
      tracking.startTracking(clientId);
    };
    /*
     * For active menu we need to pass the clientId from the parent site
     * (if it exists), to track the same user between domains.
     * For normal sites there is no clientId so we pass null
     */
    if (!Skubacz.configuration.tracking.activeMenu) {
      tracking.startTracking(null);
    }
  },

  // initEqualWidth: function () {
  //   setTimeout(function () {
  //     equalWidth()
  //   }, 250) // make sure it will run at the end
  // },

  /**
   * Execute immediately without waiting for DOM.
   */
  executeImmediately: function () {
    GroupToggle.utils.updateIdAttr()

    // replace with empty function, so we don't log errors after unload
    window.onbeforeunload = function () {
      window.onerror = function (message, url, line_number) {
      }
    };

    // TODO: Is this needed? @Damian
    // Add a no-touch class to body, so that we can disable :hover styles (elements with hover require a double tap on safari)
    if ('ontouchstart' in document) {
      $('body').removeClass('no-touch');
    }

    // TODO: is this still working? (With caching etc)
    $.ajaxSetup({
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    });
  },

  initMoment: function () {
    moment.locale(Skubacz.configuration.locale);
    $.fn.datetimepicker.defaults.locale = Skubacz.configuration.locale;
  },

  initCart: function () {
    if ($('[data-cart]').length > 0) {
      import(/* webpackChunkName: "Cart" */ './components/CartWrapper').then(mod => mod['default'].init());
    }
  },

  initCheckout: function () {
    if($(".ps-checkout").length > 0) {
      import(/* webpackChunkName: "Checkout" */ './components/CheckoutWrapper').then(mod => mod['default'].init());
    }
  },

  initOrderInfo: function () {
    if($(".ps-order-info").length > 0) {
      import(/* webpackChunkName: "OrderInfo" */ './components/OrderInfoWrapper').then(mod => mod['default'].init());
    }
  },

  initReservation: function () {
    if($("#ps-reservation").length > 0) {
      import(/* webpackChunkName: "Reservation" */ './components/ReservationWrapper').then(mod => mod['default'].init());
    }
  },

  initConsents: function () {
    if($("#ps-consents").length > 0) {
      import(/* webpackChunkName: "Consents" */ './components/ConsentsWrapper').then(mod => mod['default'].init());
    }
  },

  initSelectRestaurant: () => {
    if ($(".js-select-restaurant").length > 0) {
      import(/* webpackChunkName: "SelectRestaurant" */ '../../output/Components.SelectRestaurant/index.js').then(mod =>
        mod['default'].init({
          element: $(".js-select-restaurant"),
          country: Skubacz.configuration.country,
          accountId: Skubacz.configuration.account_id
        }));
    }
  },

  initDeliveryForm: () => {
    if ($(".js-delivery-page").length > 0) {
      import(/* webpackChunkName: "DeliveryForm" */ '../../output/Components.DeliveryForm/index.js').then(mod =>
        mod['default'].init({
          element: $(".js-delivery-page"),
          country: Skubacz.configuration.country,
          accountId: Skubacz.configuration.account_id
        }));
    }
  }
}

client.executeImmediately()

window.moment = moment
window.Skubacz.Store = Store

// Exports for tests.
// Should probably be moved to their own entry point.
window.Skubacz.loadTestExports = () =>
  import(/* webpackChunkName: "Creator" */ '../../output/Restaumatic.Site.Components.Creator/index.js').then(MenuV2Creator => {
    window.Skubacz.MenuV2Creator = MenuV2Creator;
  }).then(() => import(/* webpackChunkName: "Creator" */ '../../output/Restaumatic.Site.Components.ComboCreator/index.js')).then(ComboCreator => {
    window.Skubacz.ComboCreator = ComboCreator;
  }).then(() => import(/* webpackChunkName: "Creator" */ '../../output/Restaumatic.Site.Encoding/index.js')).then(Encoding => {
    window.Skubacz.Encoding = Encoding;
  });



function init() {
  testLocalStorage()
  client.initMoment();
  client.initTracking();
  client.initApp()
  initRating()
  client.initCart()
  client.initCheckout()
  client.initOrderInfo()
  client.initReservation()
  client.initConsents()
  client.initSelectRestaurant()
  client.initDeliveryForm()
  initCartFabAttention()
}

$(document).ready(() => {
  if(window.__pageInitHook__) {
    window.__pageInitHook__().then(init);
  } else {
    init();
  }
});


